import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@mui/styles'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { connect } from 'react-redux'
import Style from 'style-it'

const mapStateToProps = (state, ownProps) => {
  return {
    themecolors: ownProps.themecolors || state.themeColors
  }
}

const styles = theme => ({})

class CustomTextField extends React.Component {
  state = {
    showPassword: false,
  }

  togglePasswordVisibility = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }))
  }

  render () {
    const { classes } = this.props
    const isPasswordField = this.props.type === 'password'
    const { showPassword } = this.state

    const p = { ...this.props }

    delete p.dispatch

    if (isPasswordField) {
      p.type = showPassword ? 'text' : 'password'
      p.autoComplete = this.props.autoComplete || 'new-password'
      p.name = this.props.name || this.props.id || 'new-password'
    }

    const existingEndAdornment = this.props.InputProps?.endAdornment
    const passwordAdornment = isPasswordField ? (
      <InputAdornment position="end">
        <IconButton
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          onClick={this.togglePasswordVisibility}
          onMouseDown={(e) => e.preventDefault()}
          edge="end"
          size="small"
          tabIndex={-1}
          style={{ color: this.props.themecolors?.textColor || 'inherit' }}
        >
          {showPassword ? (
            <VisibilityOff fontSize="small" />
          ) : (
            <Visibility fontSize="small" />
          )}
        </IconButton>
      </InputAdornment>
    ) : null

    return (
      <Style>
        {`
					.theme-label {
						margin-top: -4px;
						font-size: 16px;
						color: ${this.props.themecolors.textColor}
					}
					
					.theme-label-focused,
					.theme-label-shrink {
						margin-top: -14px;
						margin-left: -14px
					}
					.theme-textarea {
						font-size: 16px;
						padding: 0
					}
					.theme-label-error {
						color: ${this.props.themecolors.error}
					}
					.theme-notchedOutline legend {
						width: 0 !important;
					}
					.theme-notchedOutline {
						border-color:  ${this.props.themecolors.themeLightColor}4D !important;
					}
					.theme-input-error .theme-notchedOutline {
						border-color:  ${this.props.themecolors.error} !important;
					}
					.theme-cssFocused .theme-notchedOutline {
						border-color:  ${this.props.themecolors.themeLightColor} !important;
					}
					.theme-input-select {
						border-color: ${this.props.themecolors.themeLightColor};
						color: ${this.props.themecolors.textColor};
						padding: 0;
						display: flex;
						height: auto
					}
					.theme-input {
						border-color: ${this.props.themecolors.themeLightColor};
						color: ${this.props.themecolors.textColor};
						font-size: 16px;
						padding: 5px 14px;
						min-height: 38px
					}
					.menu-list-icon {
						color: ${this.props.themecolors.textColor};
					}
					.custom-paper {
						background-color: ${this.props.themecolors.themeLightColor};
					}
				`}
        <div>
          <TextField
            margin='dense'
            {...p}
            variant='outlined'
            classes={classes}
            InputProps={{
              ...this.props.InputProps,
              endAdornment: passwordAdornment || existingEndAdornment,
              classes: {
                root: 'theme-cssOutlinedInput',
                error: 'theme-input-error',
                input: this.props.multiline ? 'theme-textarea' : 'theme-input',
                focused: 'theme-cssFocused',
                notchedOutline: 'theme-notchedOutline'
              }
            }}
            SelectProps={{
              MenuProps: {
                classes: {
                  paper: 'custom-menu-paper'
                }
              },
              classes: {
                icon: 'menu-list-icon'
              }
            }}
            InputLabelProps={{
              ...this.props.InputLabelProps,
              classes: {
                root: 'theme-label',
                focused: 'theme-label-focused',
                shrink: 'theme-label-shrink',
                error: 'theme-label-error'
              }
            }}
          />
        </div>
      </Style>
    )
  }
}

CustomTextField.propTypes = {
  classes: PropTypes.object.isRequired
}

export default connect(mapStateToProps)(withStyles(styles)(CustomTextField))
